import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { FwdRollPricingDataImpl } from "../model/impl/FwdRollPricingDataImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class FwdRollPricingDataImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: FwdRollPricingDataImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.diEventId != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        FwdRollPricingDataImplEncoder.fidTypeMap.get(1),
        false,
        encodable.diEventId,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.portfolioId != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        false,
        FwdRollPricingDataImplEncoder.fidTypeMap.get(2),
        false,
        encodable.portfolioId,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.clientCd != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        false,
        FwdRollPricingDataImplEncoder.fidTypeMap.get(3),
        false,
        encodable.clientCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.fixingDts != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        false,
        FwdRollPricingDataImplEncoder.fidTypeMap.get(4),
        false,
        encodable.fixingDts,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.fixingCd != null) {
      this.baseEncoder.writeStartFid(7, streamout);
      this.baseEncoder.writeObject(
        false,
        FwdRollPricingDataImplEncoder.fidTypeMap.get(7),
        false,
        encodable.fixingCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(7, streamout);
    }
    /*Object encoding*/
    if (encodable.lastSaveDts != null) {
      this.baseEncoder.writeStartFid(8, streamout);
      this.baseEncoder.writeObject(
        false,
        FwdRollPricingDataImplEncoder.fidTypeMap.get(8),
        false,
        encodable.lastSaveDts,
        streamout,
      );
      this.baseEncoder.writeEndFid(8, streamout);
    }
    /*Object encoding*/
    if (encodable.lastSaveUserCode != null) {
      this.baseEncoder.writeStartFid(9, streamout);
      this.baseEncoder.writeObject(
        false,
        FwdRollPricingDataImplEncoder.fidTypeMap.get(9),
        false,
        encodable.lastSaveUserCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(9, streamout);
    }
    /*Object encoding*/
    if (encodable.lastSaveUserId != null) {
      this.baseEncoder.writeStartFid(10, streamout);
      this.baseEncoder.writeObject(
        false,
        FwdRollPricingDataImplEncoder.fidTypeMap.get(10),
        false,
        encodable.lastSaveUserId,
        streamout,
      );
      this.baseEncoder.writeEndFid(10, streamout);
    }
    /*Object encoding*/
    if (encodable.netCurrencyPositions != null) {
      this.baseEncoder.writeStartFid(11, streamout);
      this.baseEncoder.writeObject(
        true,
        FwdRollPricingDataImplEncoder.fidTypeMap.get(11),
        false,
        encodable.netCurrencyPositions,
        streamout,
      );
      this.baseEncoder.writeEndFid(11, streamout);
    }
    /*Object encoding*/
    if (encodable.netDealtPairPositions != null) {
      this.baseEncoder.writeStartFid(12, streamout);
      this.baseEncoder.writeObject(
        true,
        FwdRollPricingDataImplEncoder.fidTypeMap.get(12),
        false,
        encodable.netDealtPairPositions,
        streamout,
      );
      this.baseEncoder.writeEndFid(12, streamout);
    }
    /*Object encoding*/
    if (encodable.orderAllocations != null) {
      this.baseEncoder.writeStartFid(13, streamout);
      this.baseEncoder.writeObject(
        true,
        FwdRollPricingDataImplEncoder.fidTypeMap.get(13),
        false,
        encodable.orderAllocations,
        streamout,
      );
      this.baseEncoder.writeEndFid(13, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        FwdRollPricingDataImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,FwdRollPricingDataImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "java.lang.String"],
    [2, "java.lang.String"],
    [3, "java.lang.String"],
    [4, "java.util.Date"],
    [7, "java.lang.String"],
    [8, "java.util.Date"],
    [9, "java.lang.String"],
    [10, "java.lang.Long"],
    [11, "com.bcdfx.model.fwdroll.FwdRollCurrencyNetPricing"],
    [12, "com.bcdfx.model.fwdroll.FwdRollDealtPairNetPricing"],
    [13, "com.bcdfx.model.fwdroll.FwdRollOrderAllocationPricing"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: FwdRollPricingDataImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FwdRollPricingDataImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.diEventId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 2: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FwdRollPricingDataImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.portfolioId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FwdRollPricingDataImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.clientCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            FwdRollPricingDataImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.fixingDts = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 7: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FwdRollPricingDataImplEncoder.fidTypeMap.get(7),
            streamin,
          );
          encodable.fixingCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 8: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            FwdRollPricingDataImplEncoder.fidTypeMap.get(8),
            streamin,
          );
          encodable.lastSaveDts = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 9: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FwdRollPricingDataImplEncoder.fidTypeMap.get(9),
            streamin,
          );
          encodable.lastSaveUserCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            FwdRollPricingDataImplEncoder.fidTypeMap.get(10),
            streamin,
          );
          encodable.lastSaveUserId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 11: {
          /*Object encoding*/
          let val: Array<CubiqTS.FwdRollCurrencyNetPricing> = this.baseEncoder.readObject(
            false,
            true,
            FwdRollPricingDataImplEncoder.fidTypeMap.get(11),
            streamin,
          );
          encodable.netCurrencyPositions = <Array<CubiqTS.FwdRollCurrencyNetPricing>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 12: {
          /*Object encoding*/
          let val: Array<CubiqTS.FwdRollDealtPairNetPricing> = this.baseEncoder.readObject(
            false,
            true,
            FwdRollPricingDataImplEncoder.fidTypeMap.get(12),
            streamin,
          );
          encodable.netDealtPairPositions = <Array<CubiqTS.FwdRollDealtPairNetPricing>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 13: {
          /*Object encoding*/
          let val: Array<CubiqTS.FwdRollOrderAllocationPricing> = this.baseEncoder.readObject(
            false,
            true,
            FwdRollPricingDataImplEncoder.fidTypeMap.get(13),
            streamin,
          );
          encodable.orderAllocations = <Array<CubiqTS.FwdRollOrderAllocationPricing>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FwdRollPricingDataImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,FwdRollPricingDataImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return FwdRollPricingDataImplEncoder.fidTypeMap.has(fid);
  }
}
